import {cs}    from "@Common/react/chain-services";
import {Load2} from "@Common/react/load2";

import {getImgDataIndex} from "../draw-img/get-img-data-index";

import {loadImgData} from "./load-img-data";
import {readColor}   from "./read-color";

export const LoadRawImg = ({url, next}) => cs(
    ["data", ({}, next) => Load2({
        _key: url,
        fetch: () => !url ? null : loadImgData(url),
        next,
    })],
    ({data}) => next(!url ? (
        null
    ) : data.loading ? {
        loading: true,
    } : {
        // imgData: data.value?.imgData,
        canvas : data.value.canvas,
        size: {
            width: data.value.canvas.width,
            height: data.value.canvas.height,
        },
        getDataRect: (rect) => {
            const ctx = data.value.canvas.getContext("2d");
            return ctx.getImageData(rect.x, rect.y, rect.width, rect.height);
        },
        getPColor: (p) => {
            return readColor(data.value?.imgData.data, getImgDataIndex(p, data.value?.imgData.width));
        },
    }),
);

